/**
 * @generated SignedSource<<d9dc2e42fcc8b3de484027ba01079317>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FieldDetailsAttributesFragment$data = {
  readonly length: number | null;
  readonly managementPackageSetting: {
    readonly enableWidth: boolean;
  } | null;
  readonly registeredArea: number;
  readonly units: number | null;
  readonly width: any | null;
  readonly " $fragmentType": "FieldDetailsAttributesFragment";
};
export type FieldDetailsAttributesFragment$key = {
  readonly " $data"?: FieldDetailsAttributesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FieldDetailsAttributesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FieldDetailsAttributesFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ManagementPackageSettingsNode",
      "kind": "LinkedField",
      "name": "managementPackageSetting",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enableWidth",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registeredArea",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "length",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "width",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "units",
      "storageKey": null
    }
  ],
  "type": "FieldNode",
  "abstractKey": null
};

(node as any).hash = "f5cd195eaf39bcedb2e271a7a7e2e0cf";

export default node;
